export default __webpack_public_path__ + "static/media/monitor-early.7937d8b7.png";